<template>
    <div class="report-comment">
        <button-header left-title="취소" title="신고" right-title="등록" v-on:leftClickEvent="closePopup" v-on:rightClickEvent="registReport" />

        <div v-if="commentNo > 0" class="comment-block">
            <div class="left">
                <img v-if="comment.profile_image_url != null" :src="comment.profile_image_url" width="30" height="30" />
                <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/base/image/common/avata.png" width="30" height="30" />
            </div>
            <div class="right">
                <div class="title">
                    <div>{{ comment.member_name }} <span style="color: #666668">{{ comment.comment_regist_date | convertDateYYYYMMDD }}</span></div>
                </div>
                <div class="comment">
                    {{ comment.comment }}
                </div>
                <div class="footer">
                    <best interest-div="31" :related-no="comment.comment_no" />
                </div>
            </div>
        </div>

        <div v-else class="reply-block">
            <div class="right">
                <div class="title">
                    <div>{{ comment.member_name }} <span style="color: #666668">{{ comment.reply_regist_date | convertDateYYYYMMDD }}</span></div>
                </div>
                <div class="comment">
                    {{ comment.comment }}
                </div>
            </div>
        </div>

        <div class="report-block">
            <ul class="report-reason-list">
                <li @click="report.reason = 10">
                    <div class="icon"><ion-icon mode="ios" v-bind:color="(report.reason === 10) ? 'primary' : 'medium'" name="checkmark"></ion-icon></div>
                    <div class="text">비방/욕설</div>
                </li>
                <li @click="report.reason = 20">
                    <div class="icon"><ion-icon mode="ios" v-bind:color="(report.reason === 20) ? 'primary' : 'medium'" name="checkmark"></ion-icon></div>
                    <div class="text">판매/상업적 게시물</div>
                </li>
                <li @click="report.reason = 30">
                    <div class="icon"><ion-icon mode="ios" v-bind:color="(report.reason === 30) ? 'primary' : 'medium'" name="checkmark"></ion-icon></div>
                    <div class="text">저작권 위반</div>
                </li>
                <li @click="report.reason = 40">
                    <div class="icon"><ion-icon mode="ios" v-bind:color="(report.reason === 40) ? 'primary' : 'medium'" name="checkmark"></ion-icon></div>
                    <div class="text">게시물 도배</div>
                </li>
                <li @click="report.reason = 50">
                    <div class="icon"><ion-icon mode="ios" v-bind:color="(report.reason === 50) ? 'primary' : 'medium'" name="checkmark"></ion-icon></div>
                    <div class="text">음란글</div>
                </li>
                <li @click="report.reason = 60">
                    <div class="icon"><ion-icon mode="ios" v-bind:color="(report.reason === 60) ? 'primary' : 'medium'" name="checkmark"></ion-icon></div>
                    <div class="text">기타</div>
                </li>
            </ul>
            <div class="report-reason-comment">부당하게 신고할 경우 활동이 제한될 수 있습니다.</div>
        </div>
    </div>
</template>

<script>
    import * as ajax from "../../utils/ajax";
    import * as utils from "../../utils/utils";
    import * as alert from '../../utils/alert'
    import ButtonHeader from "../header/ButtonHeader";
    import Best from "../interest/best";
    import { checkmark } from "ionicons/icons";
    import { addIcons } from "ionicons";
    addIcons({
      "ios-checkmark": checkmark.ios,
    });

    export default {
    name: 'ReportComment',
        components: {Best, ButtonHeader},
        props: {
            commentNo: Number,
            replyNo: Number,
          reportType:{
              type: String,
            default: "10",
          },
          boardNo:{
            type:Number,
            default: -1
          }
        },
    data() {
        return {
            report: {
                reason: ""
            },
            comment: {
                "board_no": 0,
                "comment": "",
                "comment_no": 0,
                "best_comment": 0,
                "member_name": "",
                "profile_image_url": null,
                "comment_regist_date": "",
                "reply_no": 0
            }
        }
    },
    mounted() {
    },
    methods: {
        closePopup() {
            this.$emit("hideReportComment");
        },
        registReport() {
            const params = {
                board_no: this.boardNo >= 0 ? this.boardNo: this.comment.board_no,
                report_div: this.report.reason,
                report_type: this.reportType
            };
            ajax.Post(this, "/api/board/comment/report/", params, function(ref, data) {
                alert.alert("신고되었습니다.", "확인");
                ref.closePopup();
            });
        }
    },
    computed: {
    },
    watch: {
        'commentNo': function(val, oldVal) {
            ajax.Get(this, "/api/board/comment/" + val, function(ref, data) {
                ref.report.reason = "";
                ref.comment = data;
            });
        },
        'replyNo': function(val, oldVal) {
            ajax.Get(this, "/api/board/comment/reply/" + val, function(ref, data) {
                console.log(data);
                ref.report.reason = "";
                ref.comment = data;
            });
        }
    },
    filters: {
        // Filter definitions
        minuteToStringFormat(value) {
            return utils.minuteToStringFormat(value);
        },
        thousandSeparator(value) {
            return utils.thousandSeparator(value);
        },
        convertDateYYYYMMDD(value) {
            return utils.convertDateYYYYMMDD(value);
        }
    }
}
</script>

<style scoped lang="scss">
    div.report-comment {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: $seventh-color;
        z-index: 200;
    }

    div.comment-block {
        padding: 32px 24px 18px 24px;
        border-bottom: 1px solid $line-secondary-color;
        background-color: #fff;

        display: flex;

        font-size: $font-base14;

        div.left {
            width: 40px;
            margin-right: 10px;
            img {
                border-radius: 50%;
            }
        }
        div.right {
            width: 100%;
            div.footer {
                margin-top: 5px;

                display: flex;
                align-items: center;

                div.like {
                    margin: 0 10px 0 5px;
                    color: $font-third-color;
                }
            }
        }
    }
    div.reply-block {
        padding: 32px 24px 18px 24px;
        border-bottom: 1px solid $line-secondary-color;
        background-color: #fff;

        display: flex;

        font-size: $font-base14;

        div.right {
            width: 100%;
            div.footer {
                margin-top: 5px;

                display: flex;
                align-items: center;

                div.like {
                    margin: 0 10px 0 5px;
                    color: $font-third-color;
                }
            }
        }
    }

    div.report-block {
        padding: 20px 24px;

        ul.report-reason-list {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
                display: flex;
                margin-bottom: 16px;

                div.icon {
                    margin-right: 11px;
                    font-size: $font-base20;
                }
                div.text {
                    flex: auto;
                }
            }
        }
        div.report-reason-comment {
            font-size: $font-base12;
            color: $font-third-color;
        }
    }
</style>
